var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-sm font-weight-medium mb-2"},[_vm._v(" Step "+_vm._s(_vm.current)+" "),(!_vm.hideTotal)?[_vm._v("of "+_vm._s(_vm.total))]:_vm._e()],2),_c('v-progress-linear',{attrs:{"rounded":"","height":8,"value":_vm.progress,"color":"primary","background-color":"#e5e5e5","background-opacity":"100"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }